import { render } from "./CatUMedidaView.vue?vue&type=template&id=79d52753&scoped=true"
import script from "./CatUMedidaView.vue?vue&type=script&lang=js"
export * from "./CatUMedidaView.vue?vue&type=script&lang=js"

import "./CatUMedidaView.vue?vue&type=style&index=0&id=79d52753&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79d52753"]])

export default __exports__